import { formatNumber } from '@ui/lib/bignumber';

export function formatSlippage(slippage: number, postfix = '%') {
  return formatNumber(slippage * 100, {
    isTrimTrailingZero: true,
    isUseSeparator: false,
    suffix: postfix,
    smallValueMode: 'zero',
  });
}
